import { Button, Icon, Stack, Text } from '@chakra-ui/react';
import { PlusIcon, TemplateIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

type Props = unknown;

export function OptionSummarySubscribersTableEmpty(): JSX.Element {
  const i18nOptionSummarySubscribers = useTranslations('OptionSummarySubscribers');
  const i18nOptionSubscribersTableEmpty = useTranslations('OptionSubscribersTableEmpty');

  return (
    <Stack layerStyle="emptyState">
      <Icon as={TemplateIcon} boxSize="40px" color="gray.500" />
      <Text>{i18nOptionSubscribersTableEmpty('Description')}</Text>
      <Button isDisabled leftIcon={<Icon as={PlusIcon} boxSize="18px" />}>
        {i18nOptionSummarySubscribers('GrantButton')}
      </Button>
    </Stack>
  );
}

export type OptionSummarySubscribersTableEmptyProps = Props;
